export default [
  {
    header: 'R & R',
    resource: 'Registros R y R',
    action: 'menu',
  },
  {
    title: 'Registros R & R',
    route: 'registrosryr',
    icon: 'FileTextIcon',
    action: 'menu',
    resource: 'Registros R y R'
  },
  {
    title: 'Tareo Diario',
    route: 'tareodiariore',
    icon: 'fa-solid fa-users-line',
    action: 'menu',
    resource: 'Tareo Diario Re'
  },
  {
    title: 'Líder Zona',
    route: 'liderzonare',
    icon: 'UsersIcon',
    action: 'menu',
    resource: 'Lider Zona Re'
  },
]
